import {
  ChangeDetectionStrategy,
  Component,
  input,
  model,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { v7 as uuid } from 'uuid';

@Component({
  selector: 'lib-toggle',
  templateUrl: './toggle.component.html',
  styleUrl: './toggle.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ToggleComponent implements OnChanges {
  active = model<boolean>();
  textActive = input<string>();
  textInactive = input<string>();
  textTooltip = input<string>();
  id = input<string>(uuid());
  disabled = input<boolean>();

  ngOnChanges(changes: SimpleChanges) {
    if (changes.disabled?.currentValue === true && this.active()) {
      this.active.set(false);
    }
  }
  toggle(e) {
    this.active.set(e.target.checked);
  }
}
